import { IAccessDeniedSettings } from 'legacy/lut/features/partner360/jbpSettings/models/accessDeniedSettings'

import { Nullable } from '../../../../classes/models/utils'
import { parseRawSetting } from '../helpers/parseRawSetting'
import { IParsedAccessDeniedSettings } from '../models/parsedAccessDeniedSettings'

export const mapAccessDeniedSettings = (
  rawAccessDeniedSettings: string
): Nullable<IAccessDeniedSettings> => {
  const parsedAccessDeniedSettings = parseRawSetting<Nullable<IParsedAccessDeniedSettings>>({
    setting: rawAccessDeniedSettings,
    defaultValue: null,
  })

  if (!parsedAccessDeniedSettings) {
    return null
  }

  return {
    icon: parsedAccessDeniedSettings.Icon,
  }
}
